import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex container mx-auto justify-between p-6 items-center bg-gray" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Ian")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-primaryColor" }, ".", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-black bg-opacity-25" }, null, -1)
const _hoisted_5 = { class: "fixed inset-0 overflow-y-auto" }
const _hoisted_6 = { class: "flex min-h-full items-center justify-center p-4 text-center" }
const _hoisted_7 = { class: "flex flex-col md:flex-row justify-between items-center md:items-start" }
const _hoisted_8 = { class: "flex flex-col w-full md:w-1/2 space-y-6 md:space-y-10" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Let's talk")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "text-primaryColor" }, ".", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "w-full border-4 border-transparent border-l-primaryColor pl-3 text-sm" }, [
  /*#__PURE__*/_createTextVNode(" Want to say hello or just offer some feedback?"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Feel free to reach me at anytime. ")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "flex space-x-4 items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-envelope text-md" }),
  /*#__PURE__*/_createElementVNode("p", null, "ianmugenya@gmail.com")
], -1)
const _hoisted_13 = { class: "flex flex-col w-full md:w-1/2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "mt-4" }, null, -1)
const _hoisted_15 = { clas: "flex flex-col" }
const _hoisted_16 = { class: "flex space-y-4 md:space-y-0 flex-col md:flex-row justify-between md:space-x-4" }
const _hoisted_17 = { class: "flex flex-col" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "text-sm font-bold" }, "Name", -1)
const _hoisted_19 = { class: "flex flex-col" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "text-sm font-bold" }, "Email", -1)
const _hoisted_21 = { class: "mt-8 text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_TransitionChild = _resolveComponent("TransitionChild")!
  const _component_DialogTitle = _resolveComponent("DialogTitle")!
  const _component_DialogPanel = _resolveComponent("DialogPanel")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_TransitionRoot = _resolveComponent("TransitionRoot")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "text-4xl font-bold"
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _hoisted_3
        ]),
        _: 1
      }),
      _createElementVNode("button", {
        class: "w-32 btns border-2 border-black py-2 hover:text-white font-bold hover:bg-primaryColor ease-out duration-300 hover:scale-[1.1]",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args)))
      }, "Let's talk")
    ]),
    _createVNode(_component_TransitionRoot, {
      appear: "",
      show: _ctx.isOpen,
      as: "template"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Dialog, {
          as: "div",
          onClose: _ctx.closeModal,
          class: "relative z-10"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TransitionChild, {
              as: "template",
              enter: "duration-300 ease-out",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "duration-200 ease-in",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_TransitionChild, {
                  as: "template",
                  enter: "duration-300 ease-out",
                  "enter-from": "opacity-0 scale-95",
                  "enter-to": "opacity-100 scale-100",
                  leave: "duration-200 ease-in",
                  "leave-from": "opacity-100 scale-100",
                  "leave-to": "opacity-0 scale-95"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DialogPanel, { class: "w-full max-w-4xl transform overflow-hidden rounded-xl bg-white p-8 text-left align-middle shadow-xl transition-all" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _createVNode(_component_DialogTitle, {
                              as: "h3",
                              class: "text-4xl font-bold leading-6 text-gray-900 font-roboto"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_9,
                                _hoisted_10
                              ]),
                              _: 1
                            }),
                            _hoisted_11,
                            _hoisted_12
                          ]),
                          _createElementVNode("div", _hoisted_13, [
                            _hoisted_14,
                            _createElementVNode("div", null, [
                              _createElementVNode("form", null, [
                                _createElementVNode("div", _hoisted_15, [
                                  _createElementVNode("div", _hoisted_16, [
                                    _createElementVNode("div", _hoisted_17, [
                                      _hoisted_18,
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "w-full md:w-36 border border-black rounded-md p-2 btns focus:outline-none focus-visible:ring-2 focus-visible:ring-primaryColor focus:border-none transition-shadow",
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event))
                                      }, null, 512), [
                                        [_vModelText, _ctx.name]
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_19, [
                                      _hoisted_20,
                                      _withDirectives(_createElementVNode("input", {
                                        type: "email",
                                        class: "w-full md:w-3/4 border border-black rounded-md p-2 btns focus:outline-none focus-visible:ring-2 focus-visible:ring-primaryColor focus:border-none transition-shadow",
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.email) = $event))
                                      }, null, 512), [
                                        [_vModelText, _ctx.email]
                                      ])
                                    ])
                                  ]),
                                  _withDirectives(_createElementVNode("textarea", {
                                    class: "mt-12 w-full form-textarea h-32 focus:bg-gray-300 border border-black focus:outline-none focus-visible:ring-2 focus-visible:ring-primaryColor focus:border-none rounded-md btns transition-shadow",
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.message) = $event))
                                  }, null, 512), [
                                    [_vModelText, _ctx.message]
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("button", {
                                type: "submit",
                                class: "inline-flex justify-center rounded-md border border-transparent bg-primaryColor px-16 py-2 text-sm font-medium text-white hover:bg-orange-400 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-500 focus-visible:ring-offset-2",
                                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.sendEmail && _ctx.sendEmail(...args)))
                              }, " Send ")
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["onClose"])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}